const sethalfscrollbar = () => {
  const halfscrollbar = (window.innerWidth - document.body.clientWidth)/2  

    document.querySelector(".site-wrapper").style.padding = "3vw calc(4.5886vw - " + halfscrollbar + "px)"
    document.querySelector(".site-head-container").style.left = "calc(4.5886vw - " + halfscrollbar + "px)"
    document.querySelector(".site-head-container").style.right = "calc(4.5886vw - " + halfscrollbar + "px)"
  
  
};

window.addEventListener('load', sethalfscrollbar);


